module.exports = new __parcel__URL__("hud_battle_royale_blue_ready_up_button.d3e0c555.png").toString();